import {Dispatch} from "redux";
import {IResponse, RACARequest} from "../../Request";
import {endLoading, startLoading} from "../../../store/slices/loadingSlice";

export default async function talentFormSignUpRequest(
  dispatch: Dispatch,
  data: any,
  agencyId?: string,
): Promise<IResponse> {
  dispatch(startLoading());

  const request = new RACARequest('auth', 'signupTalentForm')
    .setData(data);

  if (agencyId) {
    request.setQueryParams('agencyId', agencyId);
  }

  const response = await request.makeRequest();

  dispatch(endLoading());

  return response;
}
